import { createContext, useContext } from "react";

const ScopeContext = createContext(null);

// contract each layer must provide
// createUser(payload) -> Promise<void>
// invalidateOnCreate(queryClient)
// routeAfterDone(roles) -> path string
// defaultRoles?: string[]
export function ScopeProvider({ value, children }) {
  return <ScopeContext.Provider value={value}>{children}</ScopeContext.Provider>;
}
export function useScope() {
  const ctx = useContext(ScopeContext);
  if (!ctx) throw new Error("useScope must be used within ScopeProvider");
  return ctx;
}
